<div id="loader-block" *ngIf="show">
</div>
<div id="loader-spin" class="{{domainIcon}}" *ngIf="show">
	<div class="spinner-border spinner-loader-border text-warning" role="status">
		<span class="sr-only">{{'g.loading' | translate}}...</span>
	</div>
</div>
